import PropTypes from 'prop-types';
import React from 'react';
import { Icon } from '@homeexchange/design';

export default class Stars extends React.Component {
    static propTypes = {
        stars: PropTypes.number
    };

    constructor() {
        super();
        this.nbStar = 5;
    }

    render() {
        if (_.isUndefined(this.props.stars)) {
            return false;
        }

        const avgRound = Math.round(this.props.stars * 2) / 2;

        return (
            <span className="stars">
                {_.times(this.nbStar, (i) => {
                    const isFull = i <= avgRound - 1;
                    const isHalf = !isFull && i < avgRound;
                    const variant = isFull ? ' full' : isHalf ? ' half' : '';
                    return (
                        <span className={`star-icon${variant}`} key={i}>
                            <Icon name="StarOutline" />
                            {(isFull || isHalf) && <Icon name="StarFilled" className="star-icon-filled" />}
                        </span>
                    );
                })}
            </span>
        );
    }
}
